import { useMutation } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { queryClient } from "shared/util/queryClient";
import { toast } from "react-hot-toast";

interface UsePostConfirmarConfiguracaoProps {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const usePostConfirmarConfiguracao = ({ onSuccess, onError }: UsePostConfirmarConfiguracaoProps = {}) => {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await http.post(
        `${api.groupPay.postConfirmarConfiguracao}?email=${encodeURIComponent(email)}`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["status-teste-email"]);
      queryClient.invalidateQueries(["configuracao-group-pay"]);
      toast.success("Email de validação enviado com sucesso!");
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || "Ocorreu uma falha ao iniciar a confirmação de configuração.";
      toast.error(errorMessage);
      if (onError) {
        onError(error);
      }
    },
  });
};

